module.exports = __webpack_public_path__ + "img/word.8aba096f.png";